// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// DONNA — Rampa Oxford, sección "¿Cómo usarla?": el botón "Descarga Guía"
// debe abrir el PDF en una pestaña nueva para poder previsualizarlo sin
// perder el lugar en la PDP. Scoped por sufijo de data-section-id (mismo
// criterio que los overrides de custom.css) para no afectar otros botones
// de otras secciones video-with-text del sitio.
document.addEventListener("DOMContentLoaded", function () {
  var guideLink = document.querySelector(
    '[data-section-id$="__video_with_text_BwqqAX"] .video-with-text__text-container-text-button a'
  );
  if (guideLink) {
    guideLink.setAttribute("target", "_blank");
    guideLink.setAttribute("rel", "noopener");
  }
});

// DONNA — Botón flotante de WhatsApp en PDP: la app "whatsapp-button"
// (custom element <gty-whatsapp-chat-button>) dibuja el botón dentro de un
// shadow root con sus propios <style> internos, así que no se puede
// reposicionar con selectores normales de custom.css (bloque 42). Acá lo
// reubicamos justo arriba de la barra sticky de compra (.sticky-atc-bar,
// altura variable según el producto — se mide en vivo, no se asume un
// valor fijo), como un botón chico pero con área de toque cómoda (44px).
// custom.css oculta el botón por opacidad hasta que esta clase se agrega,
// para que no se vea "saltar" desde su posición original.
(function () {
  function isProductTemplate() {
    return document.body.classList.contains("template-product");
  }

  function positionWhatsAppButton(host) {
    var shadow = host.shadowRoot;
    if (!shadow) return false;

    var wrapper = shadow.querySelector(".gty-wacb-wrapper");
    if (!wrapper) return false;

    var stickyBar = document.querySelector(".sticky-atc-bar");
    var stickyHeight = stickyBar ? stickyBar.getBoundingClientRect().height : 0;
    var bottomOffset = Math.round(stickyHeight + 12);

    var style = shadow.getElementById("donna-wacb-override");
    if (!style) {
      style = document.createElement("style");
      style.id = "donna-wacb-override";
      shadow.appendChild(style);
    }

    style.textContent =
      ".gty-wacb-wrapper{bottom:" +
      bottomOffset +
      "px !important;left:16px !important;right:auto !important;}" +
      ".gty-wacb-button{width:44px !important;height:44px !important;}" +
      ".gty-wacb-button svg{width:22px !important;height:22px !important;}";

    host.classList.add("donna-wacb-positioned");
    return true;
  }

  function init() {
    if (!isProductTemplate()) return;

    var tries = 0;
    var maxTries = 60; // ~15s a 250ms — el custom element puede tardar en cargar su script.
    var timer = setInterval(function () {
      tries++;
      var host = document.querySelector("gty-whatsapp-chat-button");
      var placed = host && positionWhatsAppButton(host);
      if (placed || tries >= maxTries) {
        clearInterval(timer);
      }
    }, 250);

    // La altura de la barra sticky puede cambiar (ej. al elegir una variante
    // que agrega/quita una fila, o al rotar el dispositivo) — se recalcula
    // sin volver a inyectar el <style> desde cero.
    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var host = document.querySelector("gty-whatsapp-chat-button");
        if (host) positionWhatsAppButton(host);
      }, 200);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
